import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(0.5),
    background: theme.palette.background.default,
    border: 'none !important',
    transform: 'scaleX(0.8) scaleY(1.5)',
    fontWeight: 'bold',
    '&:hover': {
      background: 'rgb(239, 239, 239)', // TODO
      border: 'none',
    }
  },
}));